module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/pocketwaka/1.png?d74adbc3f99eab63b097a8394c375612";